import React from 'react';
import './LoadingSkeleton.css';

const LoadingSkeleton = () => {
  return (
    <div className="loading-skeleton">
      <div className="card">
        <div className="skeleton-header">
          <div className="skeleton skeleton-title"></div>
          <div className="skeleton skeleton-subtitle"></div>
        </div>
        
        <div className="skeleton-chart">
          <div className="skeleton skeleton-chart-area"></div>
          <div className="skeleton-legend">
            <div className="skeleton skeleton-legend-item"></div>
            <div className="skeleton skeleton-legend-item"></div>
            <div className="skeleton skeleton-legend-item"></div>
          </div>
        </div>
        
        <div className="skeleton-stats">
          <div className="skeleton-stat">
            <div className="skeleton skeleton-stat-value"></div>
            <div className="skeleton skeleton-stat-label"></div>
          </div>
          <div className="skeleton-stat">
            <div className="skeleton skeleton-stat-value"></div>
            <div className="skeleton skeleton-stat-label"></div>
          </div>
          <div className="skeleton-stat">
            <div className="skeleton skeleton-stat-value"></div>
            <div className="skeleton skeleton-stat-label"></div>
          </div>
          <div className="skeleton-stat">
            <div className="skeleton skeleton-stat-value"></div>
            <div className="skeleton skeleton-stat-label"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton; 